<template>
  <div class="content-body">
    <div class="content-inside">
      <b-form @submit.prevent="handleSubmit">
        <b-row class="mt-1">
          <b-col sm="12">
            <p>Set the general terms and policy for the use of your loyalty program.</p>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="12" md="2">
            <h6 class="align-middle">Terms & Conditions</h6>
            <span class="align-middle sub-title">General agreement or information on the use of your loyalty
              program.</span>
          </b-col>
          <b-col sm="12" md="7">
            <b-row>
              <b-col cols="12">
                <b-form-group :invalid-feedback="errorMessage('terms_condition')" :state="isValid('terms_condition')">
                  <vue-editor class="editor" v-model="formattedTermsAndCondition"
                    :editorToolbar="customToolbar"></vue-editor>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            <hr>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="12" md="2">
            <h6 class="align-middle">Privacy Policy</h6>
            <span class="align-middle sub-title">Assurance in protecting the collected customer data for
              your loyalty program.</span>
          </b-col>
          <b-col sm="12" md="7">
            <b-row>
              <b-col cols="12">
                <b-form-group :invalid-feedback="errorMessage('privacy_policy')" :state="isValid('privacy_policy')">
                  <vue-editor class="editor" id="privacyPolicy" v-model="formattedPrivacyPolicy"
                    :editorToolbar="customToolbar"></vue-editor>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col><b-button :disabled="saving" size="lg" variant="primary" class="save-button mt-4" type="submit"
              :block="true">{{ saving ? "Saving..." : "Save" }}</b-button></b-col>
          <b-col cols="10"></b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import { mapState } from "vuex";
import notification from "../../services/notification";
export default {
  name: "userPoints",

  data() {
    return {
      saving: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }]
      ]
    };
  },
  components: {
    VueEditor
  },
  computed: {
    ...mapState("accountTerms", [
      "loading",
      "errors",
      "termsAndCondition",
      "termsOfUse",
      "privacyPolicy"
    ]),
    formattedTermsAndCondition: {
      get: function () {
        return this.termsAndCondition;
      },
      set: function (content) {
        this.$store.commit("accountTerms/termsAndCondition", content);
      }
    },
    formattedTermsOfUse: {
      get: function () {
        return this.termsOfUse;
      },
      set: function (content) {
        this.$store.commit("accountTerms/termsOfUse", content);
      }
    },
    formattedPrivacyPolicy: {
      get: function () {
        return this.privacyPolicy;
      },
      set: function (content) {
        this.$store.commit("accountTerms/privacyPolicy", content);
      }
    }
  },

  created() {
    this.initPage();
  },

  methods: {
    async handleSubmit() {
      this.saving = true;
      await this.$store.commit("accountTerms/errors", null);
      let termsAndCondition = {
        terms_condition: '<div style="font-size: 15px;">' + this.formattedTermsAndCondition + '</div>'
      };
      await this.$store.dispatch(
        "accountTerms/saveTermsAndCondition",
        termsAndCondition
      );
      let termsOfUse = {
        terms_use: '<div style="font-size: 15px;">' + this.formattedTermsAndCondition + '</div>'
      };
      await this.$store.dispatch(
        "accountTerms/saveTermsOfUse",
        termsOfUse
      );
      let privacyPolicy = {
        privacy_policy: '<div style="font-size: 15px;">' + this.privacyPolicy + '</div>'
      };
      await this.$store.dispatch(
        "accountTerms/savePrivacyPolicy",
        privacyPolicy
      );
      this.saving = false;
      if (this.errors === null) {
        notification.success("Successfully Updated");
        this.initPage();
      }
    },
    async initPage() {
      await this.$store.dispatch("accountTerms/getTermsAndCondition");
      await this.$store.dispatch("accountTerms/getPrivacyPolicy");
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return !this.errors.errors[field];
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }
      return this.errors.errors[field];
    }
  }
};
</script>

<style lang="scss">
h5 {
  font-size: 16px;
}

h6 {
  font-family: MainFontBold, sans-serif;
  font-size: 16px;
}

.ql-editor {
  height: 300px !important;
}
</style>
